import { useMemo } from 'react';
import { parseZoomValue } from 'shared/utils';
import { useQueryParams } from '../useQueryParams/useQueryParams';

type ZoomQueryParams = {
  zoom?: string | null;
};

export const useZoomFromQueryParams = (): number | undefined => {
  const [params] = useQueryParams<ZoomQueryParams>();

  return useMemo(() => parseZoomValue(params.zoom), [params.zoom]);
};
